<template>
  <div>
    <el-form
      :model="model"
      :rules="rules"
      :label-width="labelWidth"
      :label-position="labelPosition"
      class="moreSearch"
      @keyup.enter.native.prevent="searchData()"
      @submit.native.prevent
    >
      <!--  开启高级搜索 显示name为search的slot 否则不显示    -->
      <template v-if="moreSearch">
        <el-row
          v-show="!showSearch"
          type="flex"
          :gutter="30"
        >
          <el-col :span="12">
            <slot name="search" />
          </el-col>
          <el-col :span="12">
            <el-row v-show="!showSearch">
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  @click="searchData"
                >
                  搜索
                </el-button>
                <el-button
                  v-if="showResetBtn"
                  type="primary"
                  plain
                  @click="resetData"
                >
                  重置
                </el-button>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-switch
          v-model="showSearch"
          class="switchBtn"
          :style="switchBtnStyle"
          active-color="#89B6E6"
          inactive-color="#ddd"
          active-text="显示筛选条件"
          @change="changeSearch"
        />
      </template>
      <template v-if="moreSearch">
        <el-row v-show="showSearch">
          <slot />
        </el-row>
        <el-row type="flex">
          <el-col
            v-show="showSearch"
            :span="24"
          >
            <el-form-item style="display: flex; justify-content: center">
              <el-button
                type="primary"
                @click="searchData"
              >
                搜索
              </el-button>
              <el-button
                v-if="showResetBtn"
                type="primary"
                plain
                @click="resetData"
              >
                重置
              </el-button>
              <el-button @click="showSearch = false">
                收起
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <template v-if="searchBtnPosition == 'line'">
          <slot />
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item style="display: flex; justify-content: center">
                <el-button
                  type="primary"
                  @click="searchData"
                >
                  搜索
                </el-button>
                <el-button
                  v-if="showResetBtn"
                  type="primary"
                  plain
                  @click="resetData"
                >
                  重置
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row
            type="flex"
            :gutter="30"
          >
            <el-col :span="formWidth">
              <slot />
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-form-item label-width="0px">
                  <el-button
                    type="primary"
                    @click="searchData"
                  >
                    搜索
                  </el-button>
                  <el-button
                    v-if="showResetBtn"
                    type="primary"
                    plain
                    @click="resetData"
                  >
                    重置
                  </el-button>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "MoreSearch",
  props: {
    model: {
      type: Object,
      default() {
        return {};
      },
    },
    rules: {
      type: Object,
      default() {
        return {};
      },
    },
    labelWidth: {
      type: String,
    },
    formWidth: {
      type: String,
      default: "12",
    },
    labelPosition: {
      type: String,
      default: "right",
    },
    moreSearch: {
      // 是否显示高级搜索
      type: Boolean,
      default: true,
    },
    switchBtnStyle: {
      type: String,
      default: "",
    },
    searchBtnPosition: {
      //line 单独一行,inline 和输入框一行
      type: String,
      default: "line",
    },
    showResetBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showSearch: true,
    };
  },
  methods: {
    searchData() {
      this.$emit("search");
    },
    resetData() {
      this.$emit("reset");
    },
    changeSearch(e) {
      this.$emit("changeSearch", e);
    },
  },
};
</script>

<style scoped lang="less">
.moreSearch {
  position: relative;
}
* {
  font-size: 14px;
}
.switchBtn {
  position: absolute;
  top: -40px;
  right: 0px;
}
</style>
